module.exports = __webpack_public_path__ + "img/pix-logotipo.b4f4df4d.png";